// extracted by mini-css-extract-plugin
export var label = "_k3-2";
export var slideContainer = "_k3-0";
export var slider = "_k3-1";